import { css } from '@emotion/react';
import { Flex, Text, desktopFirstMediaQuery } from '@inflearn/ds-react';

export const SettingRow = ({
  label,
  labelRightSection,
  align = 'center',
  children,
  isEditMode = false,
  isRequired = false,
}: {
  label: string;
  labelRightSection?: React.ReactNode;
  align?: 'start' | 'center';
  children: React.ReactNode;
  isEditMode?: boolean;
  isRequired?: boolean;
}) => (
  <Flex align={align} w="100%" gap={8} css={styleRow}>
    <Flex align="center" css={styleLabel} gap={8}>
      <Text
        component={isEditMode ? 'label' : 'div'}
        size="md"
        fw={500}
        py={8}
        color="gray.9"
        css={styleLabelText}
      >
        {label}
      </Text>
      {isRequired ? (
        <Text size={14} c="red" fw={500}>
          *
        </Text>
      ) : (
        labelRightSection
      )}
    </Flex>
    <Flex css={styleContent}>{children}</Flex>
  </Flex>
);

const styleRow = css({
  [desktopFirstMediaQuery.mobile]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '4px',
  },
});

const styleLabel = css({
  flex: '0 0 140px',
  [desktopFirstMediaQuery.mobile]: {
    flex: '0 0 auto',
  },
});

const styleLabelText = css({
  flex: '0 0 auto',
  [desktopFirstMediaQuery.mobile]: {
    flex: '0 0 auto',
  },
});

const styleContent = css({
  flex: '1 1 auto',
  width: '100%',
  minWidth: 0,
});
